import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/SupplierAgentCommission`;

const headers = {
  'Content-Type': 'multipart/form-data',

};
const ApiSupplierAgentCommission = {
  getAllSupplierAgentCommissions: (params) => {
    const url = `${baseServiceUrl}/GetAllSupplierAgentCommissions`;
    return ServiceApi.get(url, { params });
  },
  getSupplierAgentCommissionsWithoutPagination: (params) => {
    const url = `${baseServiceUrl}/GetSupplierAgentCommissions`;
    return ServiceApi.get(url, { params });
  },
  getSupplierAgentCommission: (params) => {
    const url = `${baseServiceUrl}/GetSupplierAgentCommission`;
    return ServiceApi.get(url, { params });
  },
  editSupplierAgentCommission: (params) => {
    const url = `${baseServiceUrl}/EditSupplierAgentCommission`;
    return ServiceApi.post(url, params, { headers });
  },
  editSupplierAgentCommissionInGroup: (params) => {
    const url = `${baseServiceUrl}/EditSupplierAgentCommissionInGroup`;
    return ServiceApi.post(url, params, { headers });
  },
};

export default ApiSupplierAgentCommission;


